export default "__VITE_ASSET__Bp4w$3Uj__"